import STORE from '../../store';

const deleteGoal = async (goal: GeneralGoal, accountId: string) => {
  const { id } = goal;

  await STORE.visualisations
    .getGoalsRef({ accountId })
    .doc(id)
    .update({ isHidden: true });
};

export default deleteGoal;
